import { UserFeature } from '__generated__/globalTypes';
import {
  PersonalisedTodayContent_user_dailySelection_afterWork,
  PersonalisedTodayContent_user_dailySelection_beforeWork,
  PersonalisedTodayContent_user_dailySelection_duringWork,
} from './__generated__/PersonalisedTodayContent';
import { DailySelectionTool } from './PersonalisedTodayScreen';

export const calculateSupportFeatureCount = (
  isManagerExperienceActive: boolean,
  userFeatures?: UserFeature[],
) => {
  const featureChecks = [
    { feature: UserFeature.TALK, condition: true },
    { feature: UserFeature.HELP, condition: true },
    {
      feature: UserFeature.LINE_MANAGER_CONTENT,
      condition: isManagerExperienceActive,
    },
  ];

  return featureChecks.reduce(
    (count, { feature, condition }) =>
      userFeatures?.includes(feature) && condition ? count + 1 : count,
    1, // Start with 1 as Wellbeing Tools card is always shown
  );
};

export const getToolsForYourDay = (
  beforeWork: PersonalisedTodayContent_user_dailySelection_beforeWork[],
  duringWork: PersonalisedTodayContent_user_dailySelection_duringWork[],
  afterWork: PersonalisedTodayContent_user_dailySelection_afterWork[],
): DailySelectionTool[] => {
  const toolSelectors = [
    { tools: beforeWork, index: 1 }, // Skip Daily Boost at index 0
    { tools: duringWork, index: 0 },
    { tools: afterWork, index: 0 },
  ];

  return toolSelectors
    .filter(({ tools, index }) => tools.length > index)
    .map(({ tools, index }) => tools[index]);
};
